export enum EProjectPublishMethod {
  none = 0,
  publish = 1,
  downloadApp = 2,
  android = 3,
  ios = 4,
  api = 5,
  webUi = 6,
  electron = 10,
  reactNative = 12
}
